import { useParams } from "react-router-dom"

export type PathParams<T extends { params: { [key: string]: (id: string) => unknown } }> = {
  [K in keyof T["params"]]: ReturnType<T["params"][K]>;
};

export function usePathParams<T extends { params: { [key: string]: (id: string) => unknown } }>(pathObject: T): PathParams<T> {
  type ParamKey = keyof T["params"] & string;
  const rawParams = useParams<Record<string, string>>();
  const paramKeys = Object.keys(pathObject.params) as ParamKey[];

  const value = paramKeys.reduce((acc, key) => {
    const rawValue = rawParams[key];

    if (rawValue !== undefined) {
      acc[key] = pathObject.params[key](rawValue) as PathParams<T>[typeof key];
    }
    return acc;
  }, {} as PathParams<T>);

  for (const key of paramKeys) {
    if (value[key] === undefined) {
      throw new Error(`Required path parameter "${key}" is missing from the URL.`);
    }
  }

  return value;
}
